import type { ComponentProps } from 'react';
import { cn } from '@/clientOnlyUtils/cn';
import React from 'react';

export function Kbd({ children }: ComponentProps<'div'>) {
  return (
    <span
      className={cn(
        'inline-block min-w-4 rounded-md bg-neutral-200 px-1 py-0.5 text-center align-baseline text-2xs font-normal capitalize text-neutral-500',
      )}>
      {children}
    </span>
  );
}
